<template>
  <div class="adminhome-wrap">
    <el-container style="min-height: 700px; border: 1px solid #eee; background: #fff;">
      <el-aside width="200px">
        <el-menu router default-active="2" class="el-menu-vertical-demo" style="border-right: none;">
          <el-menu-item index="/admin">
            <i class="el-icon-user-solid"></i>
            <span slot="title">个人中心</span>
          </el-menu-item>
          <el-menu-item index="/admin/myself">
            <i class="el-icon-user-solid"></i>
            <span slot="title">账户管理</span>
          </el-menu-item>
          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-menu"></i>
              <span>内容管理</span>
            </template>
            <el-menu-item index="/admin/createhelplist">问答</el-menu-item>
            <el-menu-item index="/admin/createactivitylist" :disabled="userinfo && userinfo.realstate !== 3">活动</el-menu-item>
            <el-menu-item index="/admin/createoldstufflist" :disabled="userinfo && userinfo.realstate !== 3">二手</el-menu-item>
            <el-menu-item index="/admin/company" :disabled="userinfo && userinfo.companystate !== 3">招聘</el-menu-item>
            <el-menu-item index="/admin/articlelist" :disabled="userinfo && userinfo.realstate !== 3">文章/新闻</el-menu-item>
          </el-submenu>
          <el-menu-item index="/admin/notice">
            <i class="el-icon-bell"></i>
            <span slot="title">通知中心</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-container>
        <el-main>
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AdminIndex',
  computed: {
    ...mapState({
      userinfo: (s) => s.user.userinfo
    })
  }
}
</script>
